const d3 = require("d3");
const { hourToXLocation } = require("../visualHelperFunctions.js")
const {getFeatures} = require("@/simulation/automation/Features.js");
const { isAssignAllowed } = require("@/simulation/automation/automator.js");

class TaskVisuals {
    constructor(visualiser, projectVisual, taskLocations) {
        this.visualiser = visualiser;
        this.projectVisual = projectVisual;
        this.taskLocations = taskLocations;
        this.createTaskElements();
        this.createConnectionLines();
    }

    createTaskElements() {
        var self = this;
        var params = this.visualiser.params;
        this.taskToLocationDict = {};

        this.taskLocations.forEach(currTaskLoc => {
            this.taskToLocationDict[currTaskLoc.task.taskName] = { x: currTaskLoc.x1, y: currTaskLoc.y1 }
        })



        this.taskElements = this.projectVisual.projectGroup.selectAll("taskRects")
            .data(this.taskLocations)
            .enter()
            .append("g")
            .attr("class", "taskGroup")
            .attr("transform", function (d) { self.taskToLocationDict[d.task.taskName].x = hourToXLocation(d.task.startHour, self.visualiser); self.currYVal = d.y1; return `translate(${self.taskToLocationDict[d.task.taskName].x}, ${d.y1})`; })
        this.taskElements
            .append("rect")
            .attr("width", d => d.x2 - d.x1)
            .attr("height", d => d.y2 - d.y1)
            .attr("fill", d => params.colorMapper[d.task.resourceGroupID])
            .attr("class", "task")
            .attr("style", "outline: thin solid white;")
            .attr("rx", function (d) { return self.getTaskStyle(d) })
            .attr("ry", function (d) { return self.getTaskStyle(d) })
            .attr("opacity", function (d) { if (d.task.isFinished()) { return 0.25; } else { return 1; } })

        this.taskElements.append("text")
            .text(d => d.task.resourceGroupID)
            .attr("pointer-events", "none")
            .attr("style", "fill: #F0F0F0;")
            .attr("text-anchor", "middle")
            .attr("dominant-baseline", "middle")
            .attr("y", d => 2 + params.taskYSize / 2)
            .attr("x", d => 2 + (d.x2 - d.x1) / 2 - 2);
    }

    //Get the radius whether it is assigned or not
    getTaskStyle(d) {
        var rSize = 0;
        if (d.task.currentResource != null) {
            rSize = 10;
        }

        return rSize;
    }

    updateElements(duration) {
        var self = this;

        var isDragging = this.visualiser.assignHandler.draggingClone != null;
        var resourceType =  this.visualiser.assignHandler.draggingResource;
        
        this.taskElements
            .selectAll("rect")
            .transition()
            .ease(d3.easeLinear)
            .duration(250)
            .attr("rx", function (d) { return self.getTaskStyle(d) })
            .attr("ry", function (d) { return self.getTaskStyle(d) })
            .attr("opacity", function (d) { if (d.task.isFinished() || (isDragging && !(isAssignAllowed(d.task, resourceType, true) && d.task.isReadyToStart() && !d.task.isFinished()))) { return 0.25; } else { return 1; } })
        
        this.taskElements.selectAll("rect").on('click', function(d,i) {
            getFeatures(d.srcElement.__data__.task, self.visualiser.simulator);
        });

        this.taskElements
            .transition()
            .ease(d3.easeLinear)
            .duration(duration)
            .attr("transform", function (d) { self.taskToLocationDict[d.task.taskName].x = hourToXLocation(d.task.startHour, self.visualiser); self.currYVal = d.y1; return `translate(${self.taskToLocationDict[d.task.taskName].x}, ${d.y1})`; });


        this.connectionLinesVertical.filter(function (d) {
            return d.task1.isFinished();
        }).remove()
        this.connectionLinesHorizontal.filter(function (d) {
            return d.task1.isFinished();
        }).remove()
        var params = this.visualiser.params;
        this.connectionLinesVertical
            .transition()
            .ease(d3.easeLinear)
            .duration(duration)
            .attr('x1', function (d) { return self.taskToLocationDict[d.task2.taskName].x })
            .attr('y1', function (d) { return self.getConnectionYPos(d.task1, d.task2) })
            .attr('x2', function (d) { return self.taskToLocationDict[d.task2.taskName].x })
            .attr('y2', function (d) { return self.getConnectionYPos(d.task2, d.task1) })
        this.connectionLinesHorizontal
            .transition()
            .ease(d3.easeLinear)
            .duration(duration)
            .attr('x1', d => self.taskToLocationDict[d.task1.taskName].x + d.task1.totalWorkHours * self.visualiser.params.xScaling)
            .attr('y1', function (d) { return self.getConnectionYPos(d.task1, d.task2) })
            .attr('x2', d => self.taskToLocationDict[d.task2.taskName].x)
            .attr('y2', function (d) { return self.getConnectionYPos(d.task1, d.task2) })

    }

    getConnectionLines() {
        var lineArray = [];
        this.taskLocations.forEach(currTaskLoc => {
            var currTask = currTaskLoc.task;

            if (currTask.childTasks.length == 0) {
                return;
            }

            currTask.childTasks.forEach(currChildTask => {
                //Add the line if the task is on a different row
                if (currChildTask.row != currTask.row) {
                    lineArray.push({ "task1": currTask, "task2": currChildTask });
                }
                //Add a line if the end of the current task isnt the same as the start of the next
                else if (currTask.startHour + currTask.totalWorkHours != currChildTask.startHour) {
                    lineArray.push({ "task1": currTask, "task2": currChildTask });
                }
            })
        })

        return lineArray;
    }


    createConnectionLines(connectionLines) {
        var connectionLines = this.getConnectionLines();
        var self = this;
        //Create the vertical lines
        this.connectionLinesVertical = this.projectVisual.projectGroup.selectAll("connectionLines")
            .data(connectionLines)
            .enter()
            .append("line")
            .attr("class", "connectionLineVertical")
            .attr('x1', function (d) { return self.taskToLocationDict[d.task2.taskName].x })
            .attr('y1', function (d) { return self.getConnectionYPos(d.task1, d.task2) })
            .attr('x2', function (d) { return self.taskToLocationDict[d.task2.taskName].x })
            .attr('y2', function (d) { return self.getConnectionYPos(d.task2, d.task1) })
            .attr("style", "stroke: #433F40; stroke-width: 1px;");

        //Create the horizontal lines
        this.connectionLinesHorizontal = this.projectVisual.projectGroup.selectAll("connectionLines")
            .data(connectionLines)
            .enter()
            .append("line")
            .attr("class", "connectionLineHorizontal")
            .attr('x1', d => self.taskToLocationDict[d.task1.taskName].x + d.task1.totalWorkHours * self.visualiser.params.xScaling)
            .attr('y1', function (d) { return self.getConnectionYPos(d.task1, d.task2) })
            .attr('x2', d => self.taskToLocationDict[d.task2.taskName].x)
            .attr('y2', function (d) { return self.getConnectionYPos(d.task1, d.task2) })
            .attr("style", "stroke: #433F40; stroke-width: 1px;");

        this.connectionLinesVertical.filter(function (d) {
            return d.task1.isFinished();
        }).remove()
        this.connectionLinesHorizontal.filter(function (d) {
            return d.task1.isFinished();
        }).remove()
    }

    getConnectionYPos(task1, task2) {
        if (this.taskToLocationDict[task1.taskName].y == this.taskToLocationDict[task2.taskName].y) {
            return this.taskToLocationDict[task1.taskName].y + this.visualiser.params.taskYSize / 2
        }
        if (this.taskToLocationDict[task1.taskName].y > this.taskToLocationDict[task2.taskName].y) {
            return this.taskToLocationDict[task1.taskName].y;
        }
        else {
            return this.taskToLocationDict[task1.taskName].y + this.visualiser.params.taskYSize;
        }
    }
}

module.exports = { TaskVisuals };
